import React from 'react';
import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import Row from 'react-bootstrap/Row';
import RichText from 'src/components/rich_text/RichText';
import { BrazeProvider } from 'src/hooks/useBraze/useBraze';
import ArticleProductsList from './ArticleProductsList';

interface ArticleBodyProps {
  body: string;
  title: string;
  relatedProducts: ProductCard[];
  hasRelatedProducts: boolean;
  allStorageBrazeCard: AllStorageBrazeCards;
  shareComponent: React.ReactNode;
}

const ArticleBody: React.FC<ArticleBodyProps> = ({
  body,
  title,
  relatedProducts,
  hasRelatedProducts,
  allStorageBrazeCard,
  shareComponent,
}) => {
  return (
    <Container fluid="lg" className="pds-mb-5.5">
      <Container fluid className="pds-mt-5.5">
        <Row className="md:pds-justify-around">
          <Col md={hasRelatedProducts ? 8 : 12} sm={12} className="pds-pb-4">
            <RichText isArticle body={body} />
            <div className="-pds-ml-[10px]">{shareComponent}</div>
          </Col>
          {hasRelatedProducts ? (
            <BrazeProvider location="article_detail" allStorageBrazeCard={allStorageBrazeCard}>
              <ArticleProductsList title={title} relatedProducts={relatedProducts} />
            </BrazeProvider>
          ) : null}
        </Row>
      </Container>
    </Container>
  );
};

export default ArticleBody;
